import { CommonModule, DatePipe, NgForOf, NgIf } from "@angular/common";
import {
  Component,
  inject,
  OnInit,
} from "@angular/core";
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { RouterLink } from "@angular/router";
import {
  TuiAppearance,
  TuiButton,
  TuiDataList,
  TuiDropdown,
  TuiLink,
  TuiLoader,
  tuiLoaderOptionsProvider,
  TuiSizeL,
  TuiSizeS,
  TuiTextfield,
  TuiTitle,
} from "@taiga-ui/core";
import {
  TuiBreadcrumbs,
  TuiChevron,
  TuiDataListDropdownManager,
  TuiDataListWrapper,
  TuiFade,
  TuiFilterByInputPipe,
  TuiItemsWithMore,
  TuiPagination,
  TuiStatus,
  TuiStringifyContentPipe,
  TuiSwitch,
  TuiTabs,
} from "@taiga-ui/kit";
import {
  TuiCell,
  TuiNavigation,
  TuiSearch,
} from "@taiga-ui/layout";
import { TuiTable } from "@taiga-ui/addon-table";
import { IAdmin } from "../../model/interface/user";
import { AdminService } from "../../core/services/admin.service";
import { TuiComboBoxModule, TuiInputSliderModule, TuiTextfieldControllerModule } from "@taiga-ui/legacy";
import { RolesService } from "../../core/services/roles.service";
import { DisableUnlessPermissionDirective } from "../../core/directives/disable-unless-permission.directive";

interface RoleData {
  _id: string;
  name: string;
  permissions: any[];
  users: string;
}

@Component({
  selector: 'app-roles',
  imports: [
    DisableUnlessPermissionDirective,
    FormsModule,
    NgForOf,
    NgIf,
    TuiAppearance,
    TuiDataListWrapper,
    TuiBreadcrumbs,
    TuiButton,
    TuiDataList,
    TuiPagination,
    TuiDropdown,
    TuiFade,
    TuiTable,
    TuiLink,
    TuiNavigation,
    TuiTabs,
    TuiTextfield,
    TuiLink,
    TuiCell,
    TuiStatus,
    TuiItemsWithMore,
    TuiSearch,
    NgForOf,
    ReactiveFormsModule,
    TuiButton,
    TuiDataListWrapper,
    TuiLink,
    TuiSearch,
    TuiTextfield,
    CommonModule,
    TuiInputSliderModule,
    TuiTextfieldControllerModule,
    RouterLink,
    TuiComboBoxModule,
    TuiLoader,
  ],
  templateUrl: './roles.component.html',
  styleUrl: './roles.component.scss',
  providers: [DatePipe,tuiLoaderOptionsProvider({size: 'xl'})],
})
export class RolesComponent {
  protected readonly breadcrumbs = ["Royal Hospital", "Users"];
  protected readonly sizes = ["m"] as const;
  protected open = false;
  protected openDropdownsize: TuiSizeL | TuiSizeS = "s";
  protected openDropdown = false;
  protected size = this.sizes[0];


  isLoading = false;
  listOfRoles: RoleData[] = [];
  totalItems = 0; 
  pageIndex = 1; 
  pageSize = 20; 

  userData: IAdmin[] = [];
  paginatedData: IAdmin[] = [];
  userService = inject(AdminService);
  showResults: string = "";
  filters = {
    searchText: '',
    status: null,
    archived: false,
  };
  // pageIndex = 1;
  // pageSize = 5;
  total: number = 6;
  sortField = 'createdAt';
  sortOrder: number = -1;

  constructor(private datePipe: DatePipe, private rolesService : RolesService) {}

  // Form setup
  protected readonly form = new FormGroup({
    search: new FormControl(''),
    select: new FormControl(''),
  });

  protected value = null;

  protected readonly items = [
    { status: 'Active', value: true },    
    { status: 'InActive', value: false }, 
  ];

  protected stringify(item: { status: string; value: boolean } | null): string {
    if (!item) return '';
    return item.status;
  }

  ngOnInit(): void {
    this.loadRoles();
  }

  loadRoles(): void {
    this.isLoading = true;
    const payload = { page: this.pageIndex, pageSize: this.pageSize };
  
    this.rolesService.getPagedRoles(payload).subscribe(
      (response: any) => {
        console.log('Roles response:', response); // Log response for debugging
  
        if (Array.isArray(response) && response.length > 0) {
          const responseData = response[0]; // Get the first element
          this.listOfRoles = responseData.data || []; // Default to empty array if data is undefined
          this.totalItems = responseData.total || 0; // Default to 0 if total is undefined
        } else {
          this.listOfRoles = [];
          this.totalItems = 0;
        }
  
        this.isLoading = false;
      },
      (error) => {
        console.error('Error fetching roles:', error);
        this.isLoading = false;
      }
    );
  }
  

  // sort(): void {
  //   this.sortOrder = this.sortOrder === 1 ? -1 : 1;
  //   this.loadRoles();
  // }

  // applyFilters(newFilters: any): void {
  //   if (newFilters.status && typeof newFilters.status === 'object') {
  //     newFilters.status = newFilters.status.value;
  //   }
  //   this.filters = { ...this.filters, ...newFilters };
  //   this.loadUsers();
  // }

  // applySort(): void {
  //   this.loadUsers();
  // }

  // onEnter(event: KeyboardEvent): void {
  //   if (event.key === 'Enter') {
  //     this.applyFilters({ searchText: this.filters.searchText });
  //   }
  // }

  onPageChange(pageIndex: number): void {
    this.pageIndex = pageIndex;
    this.loadRoles();
  }

  onPageSizeChange(pageSize: number): void {
    this.pageSize = Number(pageSize);
    this.pageIndex = 1;
    this.loadRoles();
  }

  // clearSearch(): void {
  //   this.filters.searchText = '';
  //   this.filters.status = null; 
  //   this.applyFilters({ searchText: this.filters.searchText, status: null });
  // }

  getPageCount(): number {
    return Math.ceil(this.total / this.pageSize);
  }
}
